import { waapPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Cobra/Conversant WAAP: its provisioned services carry `External.Conversant.WAAP`
  // (the catalog card uses the synthetic `Security.WAAP`).
  { scope: 'External.Conversant.WAAP', category: 'security', route: waapPaths.service },
] as const;
